import './Footer.css';

function Footer(){
    return(
        <div className="footer">
            Made with love by humans
        </div>
    )
}

export default Footer;